import React from 'react';
export const ColorContext = React.createContext([
  {
    0: '#000000',
    1: '#000000',
    2: '#000000',
    3: '#000000',
    4: '#000000',
    5: '#000000',
  },
  () => undefined,
]);
